module.exports = __webpack_public_path__ + "static/media/hero-720.d9cb78ca.mp4";